import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { Popup } from '@leverege/ui-elements';
import S from './PopupEditorWrapper.css';
import { jsx as _jsx } from "react/jsx-runtime";
const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
export default function PopupEditorWrapper({
  variant,
  placeholder,
  onDoubleClick,
  value,
  children,
  Editor,
  popupOpts,
  onChange: pOnChange,
  editable,
  usage,
  ...rest
}) {
  const [opened, setOpened] = useState(false);
  const containerRef = useCallback(node => {
    if (node) {
      const focusable = node.querySelector(focusableElements);
      setTimeout(() => {
        focusable?.focus();
      }, 1);
    }
  }, []);
  const onChange = useCallback(evt => {
    pOnChange(evt);
    setOpened(false);
  }, [pOnChange]);
  const renderTrigger = useCallback(({
    ref
  }) => {
    return /*#__PURE__*/_jsx("div", {
      ref: ref,
      onClick: () => {
        setOpened(!opened);
      },
      className: classnames(S.editorHolder, usage === 'detail' && S.editorHolderDetail),
      children: children
    });
  }, [children, opened]);
  if (!editable) {
    return children;
  }
  if (usage === 'form') {
    return /*#__PURE__*/_jsx(Editor, {
      variant: variant,
      placeholder: placeholder,
      value: value,
      usage: usage,
      ...rest,
      onChange: onChange
    });
  }
  return /*#__PURE__*/_jsx(Popup, {
    opened: opened,
    variant: variant,
    targetAttachment: usage === 'table' ? 'top left' : 'top right',
    attachment: usage === 'table' ? undefined : 'top right',
    trigger: renderTrigger,
    close: true,
    ...popupOpts,
    children: /*#__PURE__*/_jsx("div", {
      ref: containerRef,
      onDoubleClick: stopProp,
      children: /*#__PURE__*/_jsx(Editor, {
        autoFocus: true,
        variant: variant,
        placeholder: placeholder,
        value: value,
        ...rest,
        onChange: onChange
      })
    })
  });
}
function stopProp(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}